import { CREATE_TARGETED_CONTENT, GET_ALL_TARGETED_CONTENT, UPDATE_CURRENT_CAMPAIGN, RESET_CURRENT_CAMPAIGN, GET_ACTIVE_TARGETED_CONTENT, END_TARGETED_CONTENT_EARLY } from "../constants/action-types";
import { ModelType } from "../constants/ModelType";

// INITIALIZE STATE
const initialState = {
  campaigns: {},
  currentModelType: ModelType.CUSTOMERS,
  currentCampaign: {
    DisplayName: "",
    Active: true,
    StartDate: new Date(),
    EndDate: new Date(),
    TargetGroups: [],
    TargetContent: []
  }
};

// REDUCER
export const CampaignReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_TARGETED_CONTENT: {
      const incomingCampaigns = action.payload.data;
      const campaigns = {};
      const currentModelType = action.payload.modelType;

      incomingCampaigns.forEach(campaign => {
        campaigns[campaign.id] = campaign;
      });

      return {
        ...state,
        campaigns,
        currentModelType
      };
    }

    case GET_ACTIVE_TARGETED_CONTENT: {
      const incomingCampaign = action.payload;
      const campaigns = Object.assign({}, state.campaigns);

      campaigns[incomingCampaign.id] = incomingCampaign;

      return {
        ...state,
        currentCampaign: incomingCampaign,
        campaigns: campaigns
      }
    }

    case CREATE_TARGETED_CONTENT: {
      const campaigns = Object.assign({}, state.campaigns);
      const incomingCampaign = action.payload;

      campaigns[incomingCampaign.id] = incomingCampaign;

      return {
        ...state,
        campaigns
      };
    }

    case UPDATE_CURRENT_CAMPAIGN: {
      return {
        ...state,
        currentCampaign: action.payload
      };
    }

    case RESET_CURRENT_CAMPAIGN: {
      return {
        ...state,
        currentCampaign: {
          DisplayName: "",
          ModelType: "",
          Active: true,
          StartDate: new Date(),
          EndDate: new Date(),
          TargetGroups: [],
          TargetContent: []
        }
      };
    }

    case END_TARGETED_CONTENT_EARLY: {
      const campaigns = Object.assign({}, state.campaigns);
      const deletedCampaignId = action.payload;

      delete campaigns[deletedCampaignId];

      return {
        ...state,
        campaigns
      };
    }

    default:
      return state;
  }
};
